export default __webpack_public_path__ + "static/apple-icon-152x152-db32a8926a0e05eca545a0d788a51847.png";